<template>
  <div
    class="indicator"
    :class="{ 'indicator--light': light}"
  >
    <div
      v-for="(item, index) in items"
      :key="`indicator-item-${index}`"
      class="indicator__item"
      :class="{ 
        'indicator__item--active': current === index,
        'indicator__item--link': currentSection !== 'section1' 
      }"
      role="listitem"
      @click="handleClick(item)"
    >
      <div class="indicator__text">
        <div class="indicator__number">
          {{ `0${index+1}` }}
        </div>
        <div class="indicator__name">
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Indicator',
  props: {
    items: {
      type: Array,
      required: true,
    },
    current: {
      type: Number,
      required: true,
    },
    currentSection: {
      type: String,
      required: false,
      default: '',
    },
    light: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      observer: null,
    };
  },
  mounted() {
    const indicator = document.querySelector('.indicator');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          console.log('Element is fully visible in screen');
        } else {
          console.log('Element is not fully visible in screen');
        }
      });
    });
    observer.observe(indicator);
  },
  methods: {
    handleClick(item) {
      if (this.currentSection === 'section1') {
        return;
      }
      this.$emit('click', item);
    },
  },
};
</script>

<style lang="scss" scoped>
.indicator {
  $self: &;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  &__item {
    position: relative;
    height: 19px;
    display: flex;
    &--link {
      cursor: pointer;
    }
    &--active {
      opacity: 1;
      padding-bottom: 36px;
      &::after {
        content: '';
        width: 1px;
        margin: 0 9px;
        height: 24px;
        background-color: #fff;
        opacity: 0.5;
        position: absolute;
        bottom: -2px;
      }
      &:last-child {
        padding-bottom: 0;
        padding-top: 36px;
      }
      &:last-child::after {
        top: 2px;
      }
      #{$self}__text {
        color: #fff;
        opacity: 1;
      }
      #{$self}__name {
        opacity: 1;
      }
    }
  }
  &__text {
    font-size: 16px;
    font-weight: 600;
    letter-spacing: -0.01em;
    text-align: center;
    color: #fff;
    display: flex;
    gap: 8px;
    opacity: 0.5;
  }
  &__name {
    opacity: 0;
  }

  &--light {
    #{$self}__item {
      &--active {
        &::after {
        background-color: #666;
      }
        #{$self}__text {
          opacity: 1;
          color: #000;
        }
      }
    }
    #{$self}__text {
      opacity: 0.5;
      color: #666;
    }
  }
}
</style>